<script setup lang="ts">
import IconWidget from '@pet/base.icon-widget/index.vue';
import { computed } from 'vue-demi';

interface Props {
    showBack?: boolean;
    disabled?: boolean;
    iconColor?: string;
    beforeBack?: (() => void) | (() => Promise<void>);
    customBack?: () => void;
    atSearchTab?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
    showBack: true,
    iconColor: '',
});

const setCtrl = computed(() => props.disabled && 'widget-disabled');
const expandIconColor = computed(() => {
    return {
        color: props.iconColor,
    };
});
const searchTabStyle = computed(() => props.atSearchTab && 'at-search-tab');
</script>

<template>
    <div class="expand-wrapper">
        <div class="expand-main" :class="searchTabStyle">
            <div class="expand-left" :class="setCtrl">
                <IconWidget
                    v-if="showBack"
                    type="back"
                    class="status-icon-expand"
                    :before-back="beforeBack"
                    :custom-back="customBack"
                    :style="expandIconColor"
                />
                <slot name="left" />
            </div>
            <div class="expand-right" :class="setCtrl">
                <slot name="right" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '../var.scss';

.expand-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    pointer-events: none;
    -webkit-tap-highlight-color: transparent;
}

.expand-main {
    display: flex;
    justify-content: space-between;
    pointer-events: none;
    padding: $expand-vertical-gap $expand-horizontal-gap 0;
    &.at-search-tab {
        padding: $expand-vertical-gap-search $expand-horizontal-gap-search 0;
    }
}

.expand-left,
.expand-right {
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    :deep(.icon-widget) {
        margin-bottom: $icon-widget-gap;
    }
}

.widget-disabled {
    pointer-events: none;
}
</style>
